import { store } from '../index'

function setPercentageAct(percentage) {
    return {
        type: "SET_PERCENTAGE",
        percentage: percentage
    }
}

export const setPercentage = (percentage) => {
    return store.dispatch(setPercentageAct(percentage))

}

function setCancelTokenAct(cancelToken) {
    return {
        type: "SET_CANCELTOKEN",
        cancelToken: cancelToken
    }
}

export const setCancelToken = (cancelToken) => {
    return store.dispatch(setCancelTokenAct(cancelToken))

}